module.exports = __webpack_public_path__ + "static/media/skyfall-space-logo.50b3c5df.svg";